export interface Question {
  id: number;
  text: string;
  options: string[];
}

export interface Offering {
  title: string;
  description: string;
  descriptionKey?: string;
  image: string;
  labels: string[];
}

export const QUESTION: Question = {
  id: 0,
  text: 'WHAT IS YOUR GOAL TODAY?',
  options: [
    'Increase efficiency & reduce costs',
    'Improve processes & quality',
    'Develop new digital products & platforms',
    'Successfully implement AI across the organization',
    'Drive growth & create new business models',
    'Improve customer experience',
    'Strengthen security & compliance & sovereignty',
    'Enable transformation & future readiness'
  ]
};

export const SERVICES: Offering[] = [];
export const PRODUCTS: Offering[] = [];

/*
 * export const SERVICES: Offering[] = [
 *   {
 *     title: 'AI Opportunity Assessment',
 *     descriptionKey: 'homepage.offerings.aiOpportunity.description',
 *     description:
 *       'Identify high-value AI use cases aligned with your business goals and technical readiness.',
 *     image: 'AI-OPPORTUNITY.jpg',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Successfully implement AI across the organization',
 *       'Drive growth & create new business models',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Change & Digital Transformation Enablement',
 *     descriptionKey: 'homepage.offerings.changeTransformation.description',
 *     description:
 *       'Guide your organization through digital change with structured adoption and governance frameworks.',
 *     image: 'change-digital-transformation.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Successfully implement AI across the organization',
 *       'Strengthen security, compliance & sovereignty',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Data & Analytics Foundations',
 *     descriptionKey: 'homepage.offerings.dataAnalytics.description',
 *     description:
 *       'Build robust data pipelines and analytics capabilities to unlock insights and drive decisions.',
 *     image: 'data-analytics-foundations.jpg',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Successfully implement AI across the organization',
 *       'Drive growth & create new business models',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Digital Product Strategy',
 *     descriptionKey: 'homepage.offerings.digitalProductStrategy.description',
 *     description:
 *       'Define vision, roadmap, and KPIs for digital products that deliver measurable business value.',
 *     image: 'digital-product-strategy.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Drive growth & create new business models',
 *       'Improve customer experience',
 *       'Strengthen security, compliance & sovereignty',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Innovation Workshops & Design Thinking',
 *     descriptionKey: 'homepage.offerings.innovationWorkshops.description',
 *     description:
 *       'Facilitate structured ideation sessions to generate and validate creative solutions rapidly.',
 *     image: 'innovation-workshops.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Drive growth & create new business models',
 *       'Improve customer experience',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Process Analysis & Optimization',
 *     descriptionKey: 'homepage.offerings.processAnalysis.description',
 *     description:
 *       'Map, measure, and redesign workflows to eliminate waste and improve operational performance.',
 *     image: 'process-analysis.jpg',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Process Automation (RPA + AI)',
 *     descriptionKey: 'homepage.offerings.processAutomation.description',
 *     description:
 *       'Automate repetitive tasks with robotics and AI to boost throughput and reduce human error.',
 *     image: 'process-automation.jpg',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Successfully implement AI across the organization'
 *     ]
 *   },
 *   {
 *     title: 'Rapid Prototyping & Concept Validation',
 *     descriptionKey: 'homepage.offerings.rapidPrototyping.description',
 *     description:
 *       'Build and test functional prototypes quickly to de-risk ideas before full-scale development.',
 *     image: 'rapid-prototyping.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Successfully implement AI across the organization',
 *       'Drive growth & create new business models',
 *       'Improve customer experience'
 *     ]
 *   },
 *   {
 *     title: 'Requirements Engineering & Management',
 *     descriptionKey: 'homepage.offerings.requirementsEngineering.description',
 *     description:
 *       'Capture, structure, and manage requirements to ensure alignment between stakeholders and delivery.',
 *     image: 'requirements-engineering.jpg',
 *     labels: [
 *       'Improve processes & quality',
 *       'Develop new digital products & platforms',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Service & Experience Design',
 *     descriptionKey: 'homepage.offerings.serviceExperienceDesign.description',
 *     description:
 *       'Design end-to-end service experiences across digital and physical touchpoints for maximum impact.',
 *     image: 'service-experience-design.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Drive growth & create new business models',
 *       'Improve customer experience'
 *     ]
 *   },
 *   {
 *     title: 'Technology & Solution Scouting',
 *     descriptionKey: 'homepage.offerings.technologyScouting.description',
 *     description:
 *       'Evaluate emerging technologies and vendors to find the best-fit solutions for your challenges.',
 *     image: 'technology-solution-scouting.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Successfully implement AI across the organization',
 *       'Strengthen security, compliance & sovereignty',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'UX Heuristic Evaluation',
 *     descriptionKey: 'homepage.offerings.uxHeuristic.description',
 *     description:
 *       'Assess interfaces against usability principles to identify friction points and quick wins.',
 *     image: 'ux-evaluation.jpg',
 *     labels: [
 *       'Improve customer experience',
 *       'Develop new digital products & platforms',
 *       'Improve processes & quality'
 *     ]
 *   },
 *   {
 *     title: 'UX Research & User',
 *     descriptionKey: 'homepage.offerings.uxResearch.description',
 *     description:
 *       'Conduct user research to uncover needs, behaviors, and pain points that inform product decisions.',
 *     image: 'ux-research.jpg',
 *     labels: [
 *       'Develop new digital products & platforms',
 *       'Drive growth & create new business models',
 *       'Improve customer experience'
 *     ]
 *   }
 * ];
 *
 * export const PRODUCTS: Offering[] = [
 *   {
 *     title: 'N8N',
 *     descriptionKey: 'homepage.offerings.n8n.description',
 *     description:
 *       'Visual workflow automation platform for connecting apps and services without writing code.',
 *     image: 'n8n.png',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Develop new digital products & platforms',
 *       'Successfully implement AI across the organization',
 *       'Strengthen security, compliance & sovereignty',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Synera',
 *     descriptionKey: 'homepage.offerings.synera.description',
 *     description:
 *       'Engineering design automation tool that accelerates product development through visual scripting.',
 *     image: 'Synera-Logo.svg',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Develop new digital products & platforms',
 *       'Successfully implement AI across the organization',
 *       'Drive growth & create new business models',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'AI Project Research',
 *     descriptionKey: 'homepage.offerings.aiProjectResearch.description',
 *     description:
 *       'AI-powered research assistant that accelerates project discovery and knowledge extraction.',
 *     image: 'ai-app.png',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality',
 *       'Successfully implement AI across the organization',
 *       'Strengthen security, compliance & sovereignty',
 *       'Enable transformation & future readiness'
 *     ]
 *   },
 *   {
 *     title: 'Skill-Bridge',
 *     descriptionKey: 'homepage.offerings.skillBridge.description',
 *     description:
 *       'Internal talent matching platform that connects employees to projects based on skills and goals.',
 *     image: 'skillbridge.png',
 *     labels: [
 *       'Increase efficiency & reduce costs',
 *       'Improve processes & quality'
 *     ]
 *   }
 * ];
 */

export type SlideState =
  | 'enter'
  | 'active'
  | 'exit'
  | 'enter-left'
  | 'exit-right';

export interface SlideEntry {
  question: Question | null;
  state: SlideState;
  isComplete?: boolean;
  showAll?: boolean;
}
